import React, { useState, useRef, useEffect, useCallback } from 'react';
function useStateWithCallback(initialState) {
  const [lazyState, setState] = useState(initialState);
  const cbRef = useRef<any>(null); // init mutable ref container for callbacks

  const setStateCallback = useCallback((state, cb) => {
    cbRef.current = cb; // store current, passed callback in ref
    setState(state);
  }, []);
  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(lazyState);
      cbRef.current = null;
    }
  }, [lazyState]);
  return [lazyState, setStateCallback];
}
export default useStateWithCallback;